<template>

  <div class="product-list">
    <CCard>
      <CCardHeader>
        <strong>
          گزارش فروش ماهانه
        </strong>

      </CCardHeader>

      <CCardBody class="">
                <CRow>
                  <CCol>
                    <treeselect
                        :multiple="true"
                        :async="false"
                        style="min-width: 200px"
                        append-to-body
:options="products"
                        v-model="selected_products"
                        placeholder="جستجو محصول"
                        :normalizer="normalizer_products"
                    />
                  </CCol>

                  <CCol>
                    <CButton color="primary" @click="get_data()">
                      <CIcon size="sm" name="cil-zoom"/>
                    </CButton>
                  </CCol>
                </CRow>

        <CRow>
          <CCol col="3" v-for="item in items">
            <CWidgetDropdown
                color="primary"
                :header="get_month_name(item.start_date)"
                :text="item.start_date"
            >
              <template #default>
                <CDropdown
                    color="transparent p-0"
                    placement="bottom-end"
                >
                  <template #toggler-content>
                    <CIcon name="cil-settings"/>
                  </template>
                  <CDropdownItem>Action</CDropdownItem>
                  <CDropdownItem>Another action</CDropdownItem>
                  <CDropdownItem>Something else here...</CDropdownItem>
                  <CDropdownItem disabled>Disabled action</CDropdownItem>
                </CDropdown>
              </template>
              <template #footer>
                <div v-if="item.most_sales.length>0">
                  <div class="p-1" v-for="(most_sale,index) in item.most_sales.slice(0,5)" :key="'prod_most'+index">{{most_sale.title}} ( {{most_sale.order_sum}} عدد)</div>

                </div>

              </template>
            </CWidgetDropdown>

          </CCol>
        </CRow>
      </CCardBody>
    </CCard>


  </div>

</template>

<script>
import axios from "axios";
import {bus} from "../../main";
import {CChartBarSimple, CChartLineSimple} from "@/views/charts";
import Treeselect from "@riophae/vue-treeselect";


export default {
  name: 'Login',
  components: {
    Treeselect,
    CChartBarSimple,
    CChartLineSimple
    // Use the <ckeditor> component in this view.
    // ckeditor: CKEditor.component
  },
  data() {
    return {
      start_date: '',
      end_date: '',
      fields: [
        {key: 'row_id', label: '#', _classes: 'text-center'},
        {key: 'title', label: 'کالا'},
        {key: 'product_count', label: 'تعداد', _classes: 'text-center'},
        {key: 'operation', label: 'عملیات'},
      ],
      items: [],
      selected_products: [],
      products: [],
      normalizer_products(node) {
        return {
          id: node.id,
          label: node.title.title,
        }
      },
    }
  },
  mounted() {
    this.start_date = this.get_day_before_today_in_day(10)
    this.end_date = this.get_today()
    this.get_products();
    this.get_data();

  },
  watch: {},
  methods: {
    get_month_name(date) {
      var date_month = date.split('-');
      var moth_name = ""
      switch (date_month[1]) {
        case '01':
          moth_name = "فروردین"
          break;

          case '02':
          moth_name = "اردیبهشت"
          break;
          case '03':
          moth_name = "خرداد"
          break;
          case '04':
          moth_name = "تیر"
          break;
          case '05':
          moth_name = "مرداد"
          break;
          case '06':
          moth_name = "شهریور"
          break;
          case '07':
          moth_name = "مهر"
          break;
          case '08':
          moth_name = "آبان"
          break;
          case '09':
          moth_name = "آذر"
          break;
          case '10':
          moth_name = "دی"
          break;
          case '11':
          moth_name = "بهمن"
          break;
          case '12':
          moth_name = "اسفند"
          break;
      }

      return moth_name+" "+date_month[0]

    },
    get_products() {
      var self = this;

      var formData = new FormData();
      var url = '/api/admin/product/get_products';

      axios.post(url, formData, {}).then(function (response) {

        var contents = response.data;

        self.products = contents.items;


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_data() {
      var self = this;
      var form_data = new FormData();
      form_data.append("products", this.selected_products);
      axios.post('/api/admin/report/report_monthly_sale', form_data, {}).then(function (response) {

        self.items = response.data;

      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}


</script>
